import React, { useState } from 'react'
import { Container, Input, FormGroup, Label, Row, Col, Button, Spinner } from "reactstrap";
import loginIcon from "../Assets/images/login-cropped.svg"
import { toast } from "react-toastify";
import { useAuth } from '../Contexts/AuthenticateProvider';
import { Link } from 'react-router-dom';
import Handler from '../Helpers/Handler'
import { reloadWindow, setCookie } from '../Helpers/Utils'

const Login = () => {
  const { logIn } = useAuth()
  const [login, setlogin] = useState({ mobile: '', otp: '' });
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(true)
  const [disable, setDisable] = useState(false)
  const handleChange = (e) => {
    setlogin((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
  }
  const sendOtp = async () => {
    if (Number(login?.mobile?.length) != 10) {
      toast.error('Invalid Mobile Number')
    } else {
      setLoading(true)
      setDisable(true)
      setTimeout(() => {
        setDisable(false)
      }, 30000);
      const response = await Handler({ method: 'POST', url: "/auth-customer/login-otp", data: { phone: login?.mobile } })
      if (response?.success) {
        toast.success("Otp Sended Successfully");
        setOtp(false)
      } else {
        toast.error(response?.message)
      }
      setLoading(false)
    }
  }

  const submit = async () => {
    if (Number(login?.otp?.length) !== 6) {
      toast.error('Invalid Mobile Number')
    } else {
      setLoading(true)
      const response = await Handler({ method: 'POST', url: "/auth-customer/login-verify", data: { phone: login?.mobile, otp: login?.otp, device: "lap" } })
      if (response?.success) {
        toast.success(response?.message);
        logIn(response?.data?.token)
        setCookie("token", response?.data?.token);
        setTimeout(() => {
          reloadWindow()
        }, 1500)
      } else {
        toast.error(response?.message)
      }
      setLoading(false)
    }
  }
  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (otp) {
        sendOtp()
      } else {
        submit();
      }
    }
  };
  return (
    <React.Fragment>
      <Container>
        <Row className="justify-content-center align-items-center auth">
          <Col xs={12} md={10}>
            <Row className="login-page">
              <Col xs={12} md={9} lg={5} className="shadow ">
                {otp ?
                  <>
                    <div className="text-center">
                      <h3 className="fw-bold mb-3">Login</h3>
                      <img src={loginIcon} alt="logo" className="login-icon" />
                    </div>
                    <FormGroup className="mt-3">
                      <Label for="Mobile">Enter Mobile Number :</Label>
                      <Input onKeyUp={handleKeyUp} autoComplete='off' type="text" name="mobile" disabled={!otp} placeholder="Enter Mobile Number" value={login?.mobile} id="Mobile" onChange={(e) => { (e.target.value.length <= 10 && Number(e.target.value) == e.target.value) && handleChange(e) }} />
                    </FormGroup>
                    <div className="text-center">
                      {loading ? <Spinner className="spin-loader" type="grow"></Spinner>
                        : <>
                          <Button className="login-submit w-100" onClick={() => sendOtp()}>Send OTP</Button>
                          <div className='d-flex mt-2 justify-content-center align-items-center'> <span className='me-2'>Don't have an account? </span><Link to={'/signup'}>Sign Up</Link></div>
                        </>
                      }
                    </div>
                  </>
                  :
                  <>
                    <div className="text-center">
                      <h3 className="fw-bold mb-3">Login</h3>
                      <img src={loginIcon} alt="logo" className="login-icon" />
                    </div>
                    <FormGroup className="mt-2">
                      <Label for='otp ' className='mt-2'>Enter OTP : </Label>
                      <Input onKeyUp={handleKeyUp} autoComplete='off' type="text" name="otp" className='mb-2' disabled={otp} value={login?.otp} placeholder="Enter OTP" id="otp" onChange={(e) => { ((e.target.value.length <= 6 && Number(e.target.value) == e.target.value) && handleChange(e)) }} />
                      <Button className="resend-otp  text-end ms-1" disabled={disable} onClick={() => sendOtp()}>Resend OTP ?</Button>
                    </FormGroup>

                    <div className="text-center">
                      {loading ? <Spinner className="spin-loader" type="grow"></Spinner>
                        :
                        <>
                          <Button className="login-submit w-100" onClick={() => submit()}>Login</Button>
                          {/* <Link className='mt-2 d-inline-block' to={'/signup'}>Don't have a Account ?</Link> */}
                        </>
                      }
                    </div>
                  </>
                }
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default Login